import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PermissionsConfig} from '../interface/permissions-config';
import {first} from 'rxjs/operators';
import {ApplicationsConfig} from "../interface/applications-config";

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  public getPermissionsConfig(): Observable<PermissionsConfig> {
    return this.httpClient.get(`/rest/sso/api/permissions`)
      .pipe(first()) as Observable<PermissionsConfig>;
  }

  public getApplicationsConfig(): Observable<ApplicationsConfig> {
    return this.httpClient.get(`/rest/sso/api/applications`)
      .pipe(first()) as Observable<ApplicationsConfig>;
  }


}
